export const GA_TRACKING_ID = 'G-ZE6DVK4YVC';

export const GA_CONFIG = {
  debug: import.meta.env.DEV,
  trackingId: GA_TRACKING_ID,
  anonymizeIp: true,
  cookieFlags: 'SameSite=None;Secure',
};